<template>
  <v-row v-if="errorMessages.length > 0">
    <v-col cols="12">
      <v-card flat>
        <v-card-title>処理結果</v-card-title>
        <v-divider />
        <v-card-text>
          <v-data-table
            :headers="importErrorHeaders"
            :items="errorMessages"
            :items-per-page="-1"
            disable-sort
            hide-default-footer
          >
            <template v-slot:[`item.messages`]="{ item }">
              <ul class="red--text">
                <li
                  v-for="message in item.messages"
                  :key="message"
                >
                  {{ message }}
                </li>
              </ul>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ErrorMessage',
  components: {},
  mixins: [],
  props: {
    errorMessages: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      importErrorHeaders: [
        { value: 'index', text: '行番号', align: 'start' },
        { value: 'messages', text: '内容', align: 'start' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {}
}
</script>
